(function() { window.GUID_de234926_224f_4ee5_a095_53f61f278628 = { getGuid: function() { return "de234926-224f-4ee5-a095-53f61f278628"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let ChartState;
        (function (ChartState) {
            ChartState[ChartState["Initializing"] = 1] = "Initializing";
            ChartState[ChartState["Unready"] = 2] = "Unready";
            ChartState[ChartState["Ready"] = 3] = "Ready";
            ChartState[ChartState["Running"] = 4] = "Running";
            ChartState[ChartState["Stopping"] = 5] = "Stopping";
            ChartState[ChartState["Stopped"] = 6] = "Stopped";
            ChartState[ChartState["Error"] = 7] = "Error";
            ChartState[ChartState["Finished"] = 8] = "Finished";
            ChartState[ChartState["Destroying"] = 9] = "Destroying";
        })(ChartState = Enumeration.ChartState || (Enumeration.ChartState = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ChartState.pre.js.map
